import {Buffer} from 'buffer';
import * as csv from 'csv-parse/lib/sync';
import 'regenerator-runtime/runtime';

const systeme_iso = ["Oxyg&egrave;ne / Oxygen","Hydrog&egrave;ne / Hydrogen","Carbone / Carbon","Soufre / Sulfur"]
window.Buffer = Buffer;

async function read_csv() {
    const response = await fetch('https://alphadelta.ggl.ulaval.ca/data/rres.csv', { method: 'GET'})
    .catch(error => {
        console.log(error);
    });
    const fileContent = await response.text();

    // break the textblock into an array of lines
    let contentTab = fileContent.split('\n');
    // remove one line, starting at the first position
    contentTab.splice(0,1);
    // join the array back into a single string
    let contentWithoutFirstLine = contentTab.join('\n');

    return csv.parse(contentWithoutFirstLine, {delimiter: ";"});
}

function add_table(csvParsed) {
    let data = "";
    let i = 0;

    for (const isystem in systeme_iso) {
        data += "<p><H3> " + systeme_iso[isystem] + "</H3>";
        const v = "id=table_" + isystem + "\>"
        data += "<select NAME=\"-e\" SIZE=\"7\"" + v + "\n";
        for (const param of csvParsed) {
            const desc1 = param[6];
            const desc2 = param[7];
            const desc3 = param[8];
            const test = param[11];
            const fisysteme = parseInt(test);
            if (parseInt(isystem) + 1 === fisysteme) {
                data += "<option VALUE=\"" + i + "\">" + desc1 + ";" + desc2 + ";" + desc3 + "\n";
                i = i + 1;
            }
        }
        data += "</select>\n";
    }
    return data
}

async function main() {
    let str = "";
    const csvText = await read_csv();

    str += add_table(csvText);
    return str;
}

let promise = new Promise(function(resolve, reject) {
    let result = main();
    resolve(result);
  });

promise.then((result) => {
    document.getElementById("testid").innerHTML = result;

    document.getElementById("table_0").value = "";
    document.getElementById("table_1").value = "";
    document.getElementById("table_2").value = "";
    document.getElementById("table_3").value = "";
});

